import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../../context/occ/hooks/use-occ-config';
import { getMemberSubscriptionName } from '../../../../utils/get-member-subscription-name';
import { getMemberSubscriptionTags } from '../utils/get-tags';
import { getSubscriptionEndDate, hasLastContractedPaymentBeenMade, hasSubscriptionBeenCancelled, isSubscriptionActive, isSubscriptionFrozen } from '../utils/status-utils';
import { MemberSubscriptionBase } from './base';
import { MemberSubscriptionCancellationModal } from './cancellation-modal';
const b = bemClassBuilder('v-member-subscription-recurring');
export const MemberSubscriptionRecurring = observer(props => {
    const i18n = useI18n();
    const { member: { subscriptions: subscriptionsConfig } } = useOccConfig();
    const { memberSubscriptions, isFuture, displayText, events } = props;
    const [showCancellationModal, setShowCancellationModal] = useState(false);
    const memberSubscription = isFuture && memberSubscriptions.future ? memberSubscriptions.future : memberSubscriptions.current;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(MemberSubscriptionBase, { name: getMemberSubscriptionName(i18n, memberSubscription), supportingDate: getSupportingDate(memberSubscriptions, memberSubscription, displayText, i18n, isFuture), tags: [
                    { label: displayText.recurringSubscriptionTagLabel },
                    ...getMemberSubscriptionTags(memberSubscription, !!isFuture, displayText, subscriptionsConfig)
                ], description: getDescriptionLabel(memberSubscriptions, memberSubscription, displayText, i18n, isFuture), primaryButtonProps: getPrimaryButtonProps(memberSubscriptions, displayText, events, isFuture), secondaryButtonProps: getSecondaryButtonProps(memberSubscription, displayText, setShowCancellationModal) }), _jsx(MemberSubscriptionCancellationModal, { show: showCancellationModal, displayText: displayText, endDate: memberSubscription.billingDetails.nextBillingPeriodStartsAt, subscriptionStatus: memberSubscription.status, onClose: () => {
                    setShowCancellationModal(false);
                } })] })));
});
MemberSubscriptionRecurring.displayName = 'MemberSubscriptionRecurring';
const getSupportingDate = (memberSubscriptions, memberSubscription, displayText, i18n, isFuture) => {
    return (!memberSubscriptions.future || isFuture) && !hasSubscriptionBeenCancelled(memberSubscription)
        ? i18n.displayTextLabel(displayText.startDateLabel, { date: memberSubscription.startsAt })
        : i18n.displayTextLabel(displayText.endDateLabel, {
            date: getSubscriptionEndDate(memberSubscription)
        });
};
const getDescriptionLabel = (memberSubscriptions, memberSubscription, displayText, i18n, isFuture) => {
    const showNextSubscriptionPaymentDueDateForCurrent = isSubscriptionActive(memberSubscription) && !memberSubscriptions.future;
    if ((showNextSubscriptionPaymentDueDateForCurrent || isFuture) &&
        !hasSubscriptionBeenCancelled(memberSubscription)) {
        return i18n.displayTextLabel(displayText.nextSubscriptionPaymentDueLabel, {
            nextSubscriptionPaymentDueDate: memberSubscription.billingDetails.nextBillingPeriodStartsAt
        });
    }
    else if (isSubscriptionFrozen(memberSubscription)) {
        return i18n.displayTextLabel(displayText.lastSubscriptionPaymentFailedLabel, {
            lastSubscriptionPaymentFailedDate: memberSubscription.billingDetails.currentBillingPeriodStartsAt
        });
    }
};
const getPrimaryButtonProps = (memberSubscriptions, displayText, events, isFuture) => {
    if (isFuture || hasSubscriptionBeenCancelled(memberSubscriptions.current))
        return; // They already have a future subscription or have cancelled their subscription, they can't currently change it.
    if (memberSubscriptions.canPurchaseFutureSubscription &&
        hasLastContractedPaymentBeenMade(memberSubscriptions.current)) {
        return {
            children: displayText.changeSubscriptionButtonLabel,
            onClick: events.onChangeSubscriptionButtonClicked
        };
    }
};
const getSecondaryButtonProps = (memberSubscription, displayText, setShowCancellationModal) => {
    if (!memberSubscription.isCancellationAllowed || hasSubscriptionBeenCancelled(memberSubscription)) {
        return;
    } // Only show button if allowed to cancel.
    return {
        children: displayText.cancelSubscriptionButtonLabel,
        onClick: () => setShowCancellationModal(true)
    };
};
